import { InteractivityChecker } from "@angular/cdk/a11y";

export type GetFirstNavigableElementBetweenOptions = {
    tabbableOnly?: boolean;
    selector?: string | null | undefined;
};

/**
 * Note: unlike getFirstTabbableElementAfter, this function does not take special care of audio/video elements or elements within iframes.
 *
 */
export function getFirstNavigableElementBetween(
    container: HTMLElement,
    after: HTMLElement | null,
    before: HTMLElement | null | true,
    interactivityChecker: InteractivityChecker,
    options?: GetFirstNavigableElementBetweenOptions
): HTMLElement | null {
    return getFirstNavigableElementBetweenImpl(
        container,
        after,
        before === true ? ({} as any) : before,
        interactivityChecker,
        true,
        { foundStart: after === null, last: null },
        options
    );
}

function getFirstNavigableElementBetweenImpl(
    container: HTMLElement,
    after: HTMLElement | null,
    before: HTMLElement | null,
    interactivityChecker: InteractivityChecker,
    top: boolean,
    state: { foundStart: boolean; last: HTMLElement | null; noMatch?: boolean },
    options?: GetFirstNavigableElementBetweenOptions
): HTMLElement | null {
    // todo: decide if we really want to skip the top element
    if (
        !top &&
        state.foundStart &&
        interactivityChecker.isFocusable(container) &&
        (!options?.tabbableOnly || interactivityChecker.isTabbable(container)) &&
        (!options?.selector || container.matches(options.selector))
    ) {
        if (!before) {
            return container;
        } else if (container !== before) {
            state.last = container;
        }
    }

    if (container === after) state.foundStart = true;
    if (container === before) {
        state.noMatch = state.last === null;
        return state.last;
    }

    const children = container.children;

    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < children.length; i++) {
        const navigableChild =
            children[i].nodeType === document.ELEMENT_NODE
                ? getFirstNavigableElementBetweenImpl(
                      children[i] as HTMLElement,
                      after,
                      before,
                      interactivityChecker,
                      false,
                      state,
                      options
                  )
                : null;

        if (navigableChild || state.noMatch) {
            return navigableChild;
        }
    }

    if (top && state.last) {
        return state.last;
    }
    return null;
}
